import React, { useEffect } from 'react';
import { useSelector } from 'react-redux'
import { GAME_STATUS, selectGameStatus } from '../features/game/gameSlice'

let adsLoaded = {
  DisplayAd_970_90: false,
  DisplayAd_728_90: false,
  DisplayAd_300_50: false,
}

export const DisplayAd_970_90 = () => {
  const gameStatus = useSelector(selectGameStatus)
  const collapse = gameStatus === GAME_STATUS.WAITING_START ? '' : 'collapse'

  useEffect(() => {
    if (!adsLoaded.DisplayAd_970_90) {
      (window.adsbygoogle = window.adsbygoogle || []).push({})
      adsLoaded.DisplayAd_970_90 = true
    }
  })

  return (
    <div className={`ad ad-970-90 ${collapse}`}>
      {/* <!-- ffv-flipcard-d-ad-970-90 --> */}
      <ins className="adsbygoogle"
          style={{ display: 'inline-block', width: '970px', height: '90px' }}
          data-ad-client="ca-pub-2086960305398840"
          data-ad-slot="6843758370"></ins>
    </div>
  )
}

export const DisplayAd_728_90 = () => {
  const gameStatus = useSelector(selectGameStatus)
  const collapse = gameStatus === GAME_STATUS.WAITING_START ? '' : 'collapse'

  useEffect(() => {
    if (!adsLoaded.DisplayAd_728_90) {
      (window.adsbygoogle = window.adsbygoogle || []).push({})
      adsLoaded.DisplayAd_728_90 = true
    }
  })

  return (
    <div className={`ad ad-728-90 ${collapse}`}>
      {/* <!-- ffv-flipcard-d-ad-728-90 --> */}
      <ins className="adsbygoogle"
          style={{ display: 'inline-block', width: '728px', height: '90px' }}
          data-ad-client="ca-pub-2086960305398840"
          data-ad-slot="3287656748"></ins>
    </div>
  )
}

export const DisplayAd_300_50 = () => {
  const gameStatus = useSelector(selectGameStatus)
  const collapse = gameStatus === GAME_STATUS.WAITING_START ? '' : 'collapse'

  useEffect(() => {
    if (!adsLoaded.DisplayAd_300_50) {
      (window.adsbygoogle = window.adsbygoogle || []).push({})
      adsLoaded.DisplayAd_300_50 = true
    }
  })

  return (
    <div className={`ad ad-300-50 ${collapse}`}>
      {/* <!-- ffv-flipcard-d-ad-300-50 --> */}
      <ins className="adsbygoogle"
          style={{ display: 'inline-block', width: '300px', height: '50px' }}
          data-ad-client="ca-pub-2086960305398840"
          data-ad-slot="2904513364"></ins>
    </div>
  )
}